import { memo } from 'react';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { useTranslation } from 'react-i18next';
import { InlineLink } from 'InlineLink';
import { BasicMobileBox } from '../../BasicMobileBox';
import { BasicDesktopBox } from '../../BasicDesktopBox';

function AdmissionsInfoBoxComponent({
    admissionsEmail,
    scheduleVideoChatUrl,
    mobile,
}: {
    admissionsEmail: string;
    scheduleVideoChatUrl: string;
    mobile?: boolean;
}) {
    return mobile ? (
        <AdmissionsInfoBoxMobilePresentation
            admissionsEmail={admissionsEmail}
            scheduleVideoChatUrl={scheduleVideoChatUrl}
        />
    ) : (
        <AdmissionsInfoBoxPresentation admissionsEmail={admissionsEmail} scheduleVideoChatUrl={scheduleVideoChatUrl} />
    );
}

function AdmissionsInfoBoxMobilePresentation({
    admissionsEmail,
    scheduleVideoChatUrl,
}: {
    admissionsEmail: string;
    scheduleVideoChatUrl: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'admissionsInfoBox' });
    return (
        <BasicMobileBox
            boxKey={SidebarBoxKey.admissions_info}
            heading={t('heading')}
            ctaText={t('contactUs')!}
            expandedContent={
                <AdmissionsInfoBoxPresentation
                    admissionsEmail={admissionsEmail}
                    scheduleVideoChatUrl={scheduleVideoChatUrl}
                />
            }
        />
    );
}

function AdmissionsInfoBoxPresentation({
    admissionsEmail,
    scheduleVideoChatUrl,
}: {
    admissionsEmail: string;
    scheduleVideoChatUrl: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'admissionsInfoBox' });
    return (
        <BasicDesktopBox headerText={t('heading')} boxKey={SidebarBoxKey.admissions_info}>
            {t('content', {
                admissionsEmailLink: (
                    <InlineLink href={`mailto:${admissionsEmail}`} target="_blank">
                        {admissionsEmail}
                    </InlineLink>
                ),
                scheduleVideoChatLink: (
                    <InlineLink href={scheduleVideoChatUrl} target="_blank">
                        {t('1_1_video_chat')}
                    </InlineLink>
                ),
            })}
        </BasicDesktopBox>
    );
}

export const AdmissionsInfoBox = memo(AdmissionsInfoBoxComponent);
